<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage product</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Name">
        <b-input
            type="text"
            v-model="product.name"
            placeholder="e.g. Potato"
            required>
        </b-input>
      </b-field>
      <b-field label="Brand">
        <b-input
            type="text"
            v-model="product.brand"
            placeholder="e.g. VeggieFactory"
            required>
        </b-input>
      </b-field>
      <div class="mt-2">
        <b-switch v-model="product.active">Active</b-switch>        
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manageProduct">Save</button>
    </footer>
  </div>
</template>

<script>
import ProductService from './service';

export default {
  name: 'addProduct',

  props: ['propProduct', 'category'],

  created() {
    if (this.propProduct.docId) {
      this.product = { ...this.propProduct };
    }
  },

  data() {
    return {
      isLoading: false,
      product: {}
    };
  },

  methods: {
    uploadImage() {
      UploadService(this.files[0], 'products', files[0].name)
        .then(() => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.open('Error saving image');
        });
    },

    manageProduct() {
      this.isLoading = true;

      ProductService.manageProduct(this.product, this.category).then(
        newProduct => {
          this.isLoading = false;
          const isNewProduct = !this.product.docId;
          const productObj = { ...this.product };

          if (isNewProduct) {
            productObj.docId = newProduct.id;
          }

          this.$bus.$emit('PRODUCT_UPDATE', productObj, isNewProduct);
          this.$emit('close');
          this.$toast.open('Product updated successfull');
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/products/AddProduct.vue